import React from 'react';
import Head from 'next/head';
import { ModuleBase } from '@/components';
import { isColorDark, fixColor } from '@/utils';

const EmbedModule = ({ data }) => {
  const { inlineScriptEmbed, headingSectionScript } = data || {};

  // Normalize and determine background color
  const backgroundColour = fixColor(data?.backgroundColour || '#ffffff');
  const isDark = isColorDark(backgroundColour);
  const textColorClass = isDark ? 'text-white' : 'text-black';

  return (
    <ModuleBase data={{ ...data, backgroundColour }} className="relative">
      <Head>
        {/* <meta property="qqq" content="qqq" /> */}
        {typeof window !== 'undefined' && headingSectionScript && headingSectionScript.length > 0 && (
          <script>{headingSectionScript.replace(/<script>/, '').replace(/<\/script>/, '')}</script>
        )}
        {/* <meta property="qqq2" content="qqq2" />*/}
      </Head>
      <div className={`container overflow-hidden [&_iframe]:max-w-full ${textColorClass}`}>
        <div className="flex justify-center" dangerouslySetInnerHTML={{ __html: inlineScriptEmbed }}></div>
      </div>
    </ModuleBase>
  );
};

export default EmbedModule;
